import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../LaunchComponent/LaunchDataDisplay.css";
import RecognitionSubmissionPop from "./recognitionSubmissionPop";
const RecognitionDataDisplay = ({
 mailerParent,
 mailerChild,

 setIsRecognitionGenerationClicked,
 categoryNameRecognition,

 handleReset,
 setIsRecognitionNavigatedToForm,
 setIsRecognitionMailGenerated,
 programNameRecognition,
}) => {
 const [open, setOpen] = useState(false);
 const isSubmitted = useSelector((state) => state.model.isSubmitted);
 const isRecognitionLoaded = useSelector(
  (state) => state.recognition.isRecognitionLoaded
 );

 const recognitionMail = useSelector((state) => state.recognition.recognitionMail);

 return (
  <>
   <div className="data-display-new">
    <div className="result-container">
     <div className="result-wrap">
      <div className="result-content">
       {!isRecognitionLoaded && (
        <Box
         display="flex"
         flexDirection="column"
         alignItems="center"
         sx={{
          height: "100%",
          justifyContent: "center",
         }}
        >
         <CircularProgress />
         <Typography variant="h6" marginTop={2}>
          Generating...
         </Typography>
        </Box>
       )}
       {isRecognitionLoaded && recognitionMail != "" && (
        <Stack spacing={2} sx={{ padding: "0px", background: "white" }}>
         <style>
          {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
         </style>

         <div style={{ overflowY: "scroll", border: "0px !important" }}>
          <Markdown>{recognitionMail}</Markdown>
         </div>
        </Stack>
       )}
      </div>
      <div className="result-btn-container">
       <div className="result-left">
        {isRecognitionLoaded && (
         <Button
          variant="outlined"
          sx={{ marginRight: "10px" }}
          disabled={isSubmitted ? true : false}
          onClick={() => {
           setOpen(true);
          }}
         >
          Submit For Approval
         </Button>
        )}
       </div>
       <div className="result-right">
        <img src={process.env.PUBLIC_URL + "/Images/Dislikeicon.png"} />
        <img src={process.env.PUBLIC_URL + "/Images/Likeicon.png"} />
       </div>
      </div>
     </div>
     <div className="return-wrap">
      <p
       onClick={() => {
        setIsRecognitionGenerationClicked(false);
        // dispatch(handleTeaserLoading());
        setIsRecognitionNavigatedToForm(true);
        setIsRecognitionMailGenerated(null);
       }}
      >
       {"<"} Back
      </p>
     </div>
     <RecognitionSubmissionPop
      open={open}
      setOpen={setOpen}
      mailerParent={mailerParent}
      mailerChild={mailerChild}
      modalResponse={recognitionMail}
      categoryNameRecognition={categoryNameRecognition}
      handleReset={handleReset}
      programNameRecognition={programNameRecognition}
     />
    </div>
   </div>
  </>
 );
};

export default RecognitionDataDisplay;
